import moment from 'moment';

export const formatFullDate = (input: Date | string) => {
  const date = moment(input);
  return date.format('DD/MM/YYYY HH:mm');
};
